import React from 'react';
import { Newspaper, ExternalLink } from 'lucide-react';
import { pressRelease } from '../mock';

export default function PressRelease() {
  return (
    <section className="relative border-t border-black/5">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 py-20 md:py-28">
        <div className="text-[10px] tracking-[0.28em] uppercase text-neutral-500 mb-10">
          In the Press
        </div>

        <div className="grid md:grid-cols-[80px_1fr] gap-6 md:gap-10 items-start">
          <div className="w-14 h-14 rounded-sm border border-black/10 bg-white flex items-center justify-center">
            <Newspaper className="w-6 h-6 text-neutral-700" strokeWidth={1.5} />
          </div>

          <div className="max-w-3xl">
            <h2 className="font-serif text-[28px] md:text-[38px] leading-[1.15] tracking-[-0.015em] text-neutral-900">
              {pressRelease.headline}
            </h2>
            <p className="mt-6 text-neutral-600 text-[15px] md:text-[16px] leading-relaxed">
              {pressRelease.summary}
            </p>
            <a
              href={pressRelease.url}
              className="mt-8 inline-flex items-center gap-2 bg-neutral-900 hover:bg-[#EA580C] text-[#F5F2EC] px-5 py-3 text-[13px] tracking-wide rounded-sm transition-colors duration-300"
            >
              Read the press release
              <ExternalLink className="w-3.5 h-3.5" />
            </a>
            <div className="mt-6 text-[11px] tracking-[0.22em] uppercase text-neutral-500">
              Source · {pressRelease.source}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
